









































import {
  Component,
  Emit,
  Prop,
  PropSync,
  Vue,
  Watch
} from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ServerError from '@/utils/server_error'
import userStore from '@/modules/auth/auth.store'
import tournamentStore from '@/modules/tournament/tournament.store'
import ConfirmDialog from '@/modules/shared/components/ConfirmDialog'
import VFormBase from 'vuetify-form-base'
import {
  ResponseStatus,
  TournamentAPI,
  TournamentEntity
} from '@/api/tournament'
import {
  TournamentTeamEntity,
  TournamentPlayerEntity,
  TournamentTeamRole
} from '@/api/tournamentTeam'
import { parseSchema } from '@/utils/customform_validation'
import i18n from '@/lang'

@Component({
  components: {
    ConfirmDialog,
    VFormBase
  }
})
export default class EditTournamentFormResponseDialog extends Vue {
  userModule = getModule(userStore, this.$store)
  tournamentModule = getModule(tournamentStore, this.$store)

  @PropSync('visible', { default: false }) isVisible!: boolean

  schema: any = {}
  response: any = null
  isConfirmDialogVisible: boolean = false
  isLoading: boolean = false

  /* Watchers */
  @Watch('isVisible')
  async onVisibleChange(visible: boolean) {
    if (!visible) {
      this.schema = {}
      this.response = null
    } else {
      await this.fetchTournamentTeamFormResponse()
    }
  }

  /* Methods */
  async submit() {
    this.isLoading = true
    try {
      const response = await TournamentAPI.updateTournamentFormResponse(
        this.selectedTournamentTeam!.tournamentTeamId,
        JSON.stringify(this.response)
      )
      if (response.data.status === ResponseStatus.Ok) {
        this.$toast.success(
          this.$t('EditTournamentFormResponseDialog.SubmittedMessage')
        )
        this.nameChanged()
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Loading.SystemErrorMessage'))
      }
      console.error(err)
    } finally {
      this.isLoading = false
      this.isConfirmDialogVisible = false
      this.isVisible = false
    }
  }

  async fetchTournamentTeamFormResponse() {
    try {
      const res = await TournamentAPI.getMemberTournamentFormResponse(
        this.selectedTournamentTeam!.tournamentTeamId
      )
      if (res.data.payload) {
        this.schema = parseSchema(res.data.payload.schema)
        this.response = JSON.parse(res.data.payload.value)
      }
    } catch {
      // use fallback to parse schema content
      this.fetchTournamentFormSchemaFallback()
    }
  }

  async fetchTournamentFormSchemaFallback() {
    try {
      const res = await TournamentAPI.getTournamentCustomFormSchema(
        this.selectedTournament!.tournamentId
      )
      if (res.data.payload) {
        this.schema = parseSchema(res.data.payload.schema)
        this.response = {}
      }
    } catch {
      this.isVisible = false
    }
  }

  nameChanged() {
    // this.newCaptainMemberId = ''
    // this.newGameAccountName = ''
    this.$emit('changed')
  }

  /* Computed Properties */
  get selectedTournamentTeam(): TournamentTeamEntity | null {
    return this.tournamentModule.selectedTournamentTeam
  }

  get selectedTournament(): TournamentEntity | null {
    return this.tournamentModule.selectedTournament
  }

  get game() {
    if (!this.selectedTournament) return ''

    return this.selectedTournament.game
  }

  get userId() {
    return this.userModule.userId
  }

  get players(): TournamentPlayerEntity[] {
    if (!this.selectedTournamentTeam) return []
    return this.selectedTournamentTeam.players.filter(
      player => player.role !== TournamentTeamRole.RequestToJoin
    )
  }

  get me() {
    if (!this.selectedTournamentTeam) return null

    return this.selectedTournamentTeam.players.find(
      player => player.memberId === this.userId
    )
  }

  get confirmDialogMessage() {
    return this.$t('EditTournamentFormResponseDialog.ConfirmDialogMessage')
  }
}
